import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CompanyActionsMenu = ({ company, onStatusToggle, onDuplicate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleEdit = () => {
    navigate(`/company-create-edit?id=${company?.id}`);
    setIsOpen(false);
  };

  const handleStatusToggle = () => {
    onStatusToggle(company?.id);
    setIsOpen(false);
  };

  const handleDuplicate = () => {
    onDuplicate(company);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={menuRef}>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        iconName="MoreVertical"
        iconSize={16}
      />
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-surface border border-border rounded-lg shadow-lg z-50 py-1">
          <button
            onClick={handleEdit}
            className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted transition-colors duration-150 flex items-center gap-2"
          >
            <Icon name="Edit2" size={14} />
            Edit Company
          </button>
          
          <button
            onClick={handleDuplicate}
            className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted transition-colors duration-150 flex items-center gap-2"
          >
            <Icon name="Copy" size={14} />
            Duplicate
          </button>

          <div className="border-t border-border my-1" />

          <button
            onClick={handleStatusToggle}
            className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted transition-colors duration-150 flex items-center gap-2"
          >
            <Icon name={company?.status === 'active' ? 'XCircle' : 'CheckCircle2'} size={14} />
            {company?.status === 'active' ? 'Deactivate' : 'Activate'}
          </button>
        </div>
      )}
    </div>
  );
};

export default CompanyActionsMenu;